module.exports = "<div class=\"button__icon__container\">\n\t<button class=\"{{keepAppointmentActive ? 'simple-button--active' : 'simple-button'}}\" (click)=\"setKeepAppointment()\">\n\t\t<i class=\"pin-icon\"></i>\n\t\t<span class=\"button__label\">{{keepAppointmentActive ? 'Termin wird gehalten' : 'Termin halten'}}</span>\n\t</button>\n\t<leo-info [bindPopup]=\"true\">\n\t\tNach Aktivierung des Buttons (ersichtlich durch \"Termin wird gehalten\") navigiert das System nach Abschluss\n\t\teiner Bestellung zurück in diese Veranstaltung.\n\t</leo-info>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/keep-appointment/keep-appointment.html
// module id = 58M9
// module chunks = 12